import {
  labelConfigSelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {FEDEX_360} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {useSelector} from '../../../store.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [FEDEX_360]

function materialLabelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__battery_material`]
    : []
}

function packagingLabelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__battery_packaging`]
    : []
}

export function BatteryMaterial() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [materialPropertySpecs] = BatteryMaterial.propertySpecList
  const [materialLabelProperty] = materialPropertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Battery Material"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [materialLabelProperty]: value,
        })

        onChange()
      }}
      labelProperty={materialLabelProperty}
      propertySpecs={materialPropertySpecs}
      shipperOptionsProperty="battery_materials"
    />
  )
}

BatteryMaterial.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: materialLabelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: packagingLabelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]

export function BatteryPackaging() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [materialPropertySpecs] = BatteryMaterial.propertySpecList
  const [materialLabelProperty] = materialPropertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const [packagingPropertySpecs] = BatteryPackaging.propertySpecList
  const [packagingLabelProperty] = packagingPropertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const material = useSelector((state) =>
    labelConfigSelector(state, {labelInfoID}),
  )[materialLabelProperty]

  return (
    <ConfigSelect
      label="Battery Packaging"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [packagingLabelProperty]: value,
        })

        onChange()
      }}
      labelProperty={packagingLabelProperty}
      propertySpecs={packagingPropertySpecs}
      shipperOptionsProperty="battery_packaging"
      hide={!material}
    />
  )
}

BatteryPackaging.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: packagingLabelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
